module.exports = __webpack_public_path__ + "static/img/logo03.abe1075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo03.png
// module id = opOZ
// module chunks = 1